<template>
  <component
    :is="media"
    class="kpb-media"
    :value="data"
    v-bind="options"
    :style="`--kpb-media-aspect-ratio: ${aspectRatio};`"
  />
</template>
<script>
import Types from '@kvass/media-render/Types'
import { Capitalize } from '../../utils'

/** Media component (supports : image, vimeo, youtube) */
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: 'vimeo',
    },

    options: {
      type: Object,
      default: () => ({
        displayThumbnail: true,
        controls: true,
        autoplay: false,
      }),
    },

    aspectRatio: {
      type: String,
      default: '16/9',
    },
  },
  computed: {
    media() {
      switch (this.type) {
        case 'image':
          return 'Media'
        default:
          return Types[Capitalize(this.type)]
      }
    },
  },
  methods: {
    Capitalize,
  },
  components: {
    Vimeo: Types.Vimeo,
    Youtube: Types.Youtube,
    Media: Types.Image,
  },
}
</script>

<style lang="scss">
.kpb-media {
  aspect-ratio: var(--kpb-media-aspect-ratio);
  position: relative;
  iframe {
    aspect-ratio: var(--kpb-media-aspect-ratio);
  }
}
</style>
